import { useEffect, useState } from "react";

export function useTheme() {
  const [accent, setAccent] = useState(() => localStorage.getItem("accent") || "enmax-blue");
  const [mode, setMode] = useState(() => localStorage.getItem("mode") || "light");

  useEffect(() => {
    document.documentElement.setAttribute("data-accent", accent);
    document.documentElement.setAttribute("data-mode", mode);
    localStorage.setItem("accent", accent);
    localStorage.setItem("mode", mode);
  }, [accent, mode]);

  const toggleMode = () => setMode((prev) => (prev === "light" ? "dark" : "light"));
  const setAccentTheme = (name: string) => setAccent(name);

  return { accent, mode, toggleMode, setAccentTheme };
}